/* WarningsMessageRenderer.js */

"use strict";

const eventRegisterMixin = require("../../utils/eventRegisterMixin");

/**
 * @class WarningsMessageRenderer
 *
 * @listens AddLicenseComponent#event:Data
 */

const SECTION_TITLE = "warning";

class WarningsMessageRenderer extends eventRegisterMixin() {
    constructor(model) {
        super();
        /**
         * @type {WarningsMessageComponent}
         */
        this._model = model;

        this._rootElem = this._createRootElement();
        this._rootElem.classList.add("no-warnings");
        this._warningList = document.createElement("ul");

        this._registerListeners();
        this.render();
    }

    get rootElement() {
        return this.getRootElement();
    }

    get model() {
        return this.getModel();
    }

    /*******************************************/
    /* START PUBLIC COMPONENT RENDERER METHODS */

    /*******************************************/
    render() {
        if (this._renderProm === null) {
            return Promise.resolve();
        }
        this._renderProm = this._renderProm || this._render();
        return this._renderProm;
    }

    shutdown() {
        if (this._shutdownProm === null) {
            return Promise.resolve();
        }
        this._shutdownProm = this._shutdownProm || this._shutdown();
        return this._shutdownProm;
    }

    getRootElement() {
        return this._rootElem;
    }

    getModel() {
        return this._model;
    }

    /********************************************/
    /* END PUBLIC COMPONENT RENDERER METHODS */
    /* START PRIVATE COMPONENT RENDERER METHODS */

    /********************************************/

    _registerListeners() {
        this._registerListener(this._model, "Data", this._onData.bind(this));
    }

    _unregisterListeners() {
        this._unregisterAllListeners();
    }

    _render() {
        this._rootElem.innerHTML = "";
        const root = document.createDocumentFragment();

        root.appendChild(this._createTitle());
        root.appendChild(this._renderWarningList());

        return new Promise((resolve /*,reject*/) => {
            this._rootElem.appendChild(root);
            resolve();
        });
    }

    _shutdown() {
        this._unregisterListeners();
        this._rootElem.remove();
        this._rootElem = null;

        return Promise.all([])
            .then(() => {
                this._model = null;
                this._shutdownProm = null;
                this._renderProm = null;
            })
            .catch((error) => {
                console.log(`${this.constructor.name}: error in shutdown`);
                console.error(error);
            });
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PRIVATE RENDERER METHODS */
    /*******************************************/

    _createRootElement() {
        const rootElement = document.createElement("div");
        rootElement.classList.add("solutions-warnings");
        rootElement.component = this._model;
        return rootElement;
    }

    _createTitle() {
        const title = document.createElement("div");
        title.className = "section-title";
        title.innerText = SECTION_TITLE;
        return title;
    }

    _createWarningItem(warningMsg) {
        const li = document.createElement("li");
        li.innerText = warningMsg;
        return li;
    }

    _renderWarningList(warnings = []) {
        this._warningList = this._warningList || document.createElement("ul");

        const list = warnings.reduce((list, warning) => {
            list.appendChild(this._createWarningItem(warning.msg));
            return list;
        }, document.createDocumentFragment());

        this._warningList.innerHTML = "";
        this._warningList.appendChild(list);
        return this._warningList;
    }
    /**
     *
     * @param {WarningItem[]} warnings
     * @private
     */
    _updateWarnings(warnings) {
        this._renderWarningList(warnings);
    }

    /*******************************************/
    /* END PRIVATE RENDERER METHODS  */
    /* START HANDLER METHODS */
    /*******************************************/
    _onData(data) {
        this._rootElem.classList.toggle("no-warnings", !data.length);
        this._updateWarnings(data);
    }

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/

    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = WarningsMessageRenderer;
